import React from "react";

interface ArrowIconProps {
  width?: number;
  height?: number;
  fill?: string;
  className?: string;
}

const ArrowIcon: React.FC<ArrowIconProps> = ({
  width = 18,
  height = 18,
  fill = "currentColor",
  className = "",
}) => {
  return (
    <svg
      preserveAspectRatio="none"
      width={width}
      height={height}
      overflow="visible"
      style={{ display: "block" }}
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g>
        <path
          d="M16.005 16.0123C16.002 16.0123 16 16.0143 16 16.0143L16.005 16.0123ZM2 16.0183C2 16.0143 1.998 16.0123 1.995 16.0123H2V16.0183ZM16 16.0123V10.0123H18V16.0143C18.0003 16.2765 17.9489 16.5362 17.8487 16.7785C17.7486 17.0208 17.6017 17.2411 17.4164 17.4266C17.2312 17.6122 17.0112 17.7594 16.769 17.8599C16.5268 17.9604 16.2672 18.0122 16.005 18.0123H1.995C1.46615 18.012 0.959017 17.8019 0.584968 17.428C0.210919 17.0542 0.000529846 16.5471 0 16.0183V2.00629C0 0.905288 0.896 0.0122881 1.997 0.0122881H8V2.01229H2V16.0123H16ZM2 16.0183C2 16.0143 1.998 16.0123 1.995 16.0123H2V16.0183ZM8 2.01229H2V16.0123H16V10.0123H18V16.0143C18.0003 16.2765 17.9489 16.5362 17.8487 16.7785C17.7486 17.0208 17.6017 17.2411 17.4164 17.4266C17.2312 17.6122 17.0112 17.7594 16.769 17.8599C16.5268 17.9604 16.2672 18.0122 16.005 18.0123H1.995C1.46615 18.012 0.959017 17.8019 0.584968 17.428C0.210919 17.0542 0.000529846 16.5471 0 16.0183V2.00629C0 0.905288 0.896 0.0122881 1.997 0.0122881H8V2.01229ZM16 2.01229V5.01229C16 5.2775 16.1054 5.53186 16.2929 5.71939C16.4804 5.90693 16.7348 6.01229 17 6.01229C17.2652 6.01229 17.5196 5.90693 17.7071 5.71939C17.8946 5.53186 18 5.2775 18 5.01229V1.01229C18 0.747072 17.8946 0.492718 17.7071 0.305181C17.5196 0.117645 17.2652 0.0122881 17 0.0122881H13C12.7348 0.0122881 12.4804 0.117645 12.2929 0.305181C12.1054 0.492718 12 0.747072 12 1.01229C12 1.2775 12.1054 1.53186 12.2929 1.71939C12.4804 1.90693 12.7348 2.01229 13 2.01229H16Z"
          fill={fill}
        />
        <path
          d="M9.707 9.71929L17.707 1.71929C17.8025 1.62704 17.8787 1.5167 17.9311 1.39469C17.9835 1.27269 18.0111 1.14147 18.0123 1.00869C18.0134 0.87591 17.9881 0.74423 17.9378 0.621334C17.8875 0.498438 17.8133 0.386786 17.7194 0.292893C17.6255 0.199001 17.5138 0.124747 17.391 0.0744666C17.2681 0.0241857 17.1364 -0.00111606 17.0036 3.77567e-05C16.8708 0.00119157 16.7396 0.0287779 16.6176 0.0811869C16.4956 0.133596 16.3852 0.209778 16.293 0.305288L8.293 8.30529C8.11084 8.49389 8.01005 8.74649 8.01233 9.00869C8.0146 9.27089 8.11977 9.5217 8.30518 9.70711C8.49059 9.89251 8.7414 9.99768 9.0036 9.99996C9.2658 10.0022 9.5184 9.90145 9.707 9.71929Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default ArrowIcon;
